export default "__VITE_ASSET__9deb22db__"